import { useQueryClient } from 'shared-ui';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

import { deleteCard } from 'api/cards/cards';
import { QueryKeyEnum } from 'core/global.enum';
import { useLocale } from 'hooks/useLocale/useLocale';
import { AppMessages } from 'i18n/messages';
import { useSelectedCard } from 'hooks/useSelectedCard/useSelectedCard';
import { useMutation } from 'hooks/useMutation/useMutation';
import { AppRoute, AppRouteWithParams } from 'routing/AppRoute.enum';
import { useModalState } from 'hooks/useModalState/useModalState';
import { useIsExactPath } from 'hooks/useIsExactPath/useIsExactPath';

import { DeleteCard } from './DeleteCard';
import { DeleteCardContainerProps } from './DeleteCard.types';

export const DeleteCardContainer = ({ selectedCard }: DeleteCardContainerProps) => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const isHistoryView = useIsExactPath(AppRouteWithParams.cardHistory.path);
  const { formatMessage } = useLocale();
  const { setSelectedCard } = useSelectedCard();

  const { isModalOpen, onModalOpen, onModalClose } = useModalState();

  const { mutate: onDeleteCard, isLoading } = useMutation(deleteCard, {
    onSuccess: () => {
      setSelectedCard(undefined);
      queryClient.invalidateQueries([QueryKeyEnum.CARDS]);
      isHistoryView && navigate(AppRoute.cards);
      toast.dark(formatMessage({ id: AppMessages['card.delete.success'] }));
      onModalClose();
    },
  });

  const onSubmit = () => {
    onDeleteCard(selectedCard.id);
  };

  return (
    <DeleteCard
      selectedCard={selectedCard}
      isModalOpen={isModalOpen}
      onModalClose={onModalClose}
      onModalOpen={onModalOpen}
      isLoading={isLoading}
      onSubmit={onSubmit}
    />
  );
};
